/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import { Checkbox } from "@mui/material";
import {
  ALL_DATES,
  INTEGER_KEYS,
  AppliedFilterLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../contants";
import { ROUTES } from "../../utils/constants";
import { isEmptyObj, isOSKey } from "../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd hh':'mm':'ss";
const PLUS = "plus";
const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "positions";
export const MAINLINE_POSITION_KEY = "mainlinePositions";

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getRoutePath = () => ROUTES.SG_INDUCTION.path;
export const getGraduationRoutePath = () => ROUTES.SG_GRADUATION.path;
export const getDivisionRoutePath = () => ROUTES.SG_DIVISION.path;

export const getAdminRoutePath = () =>
  ROUTES.USER_MANAGEMENT_MEMBER_SEARCH.path;

const handlePositions = (queryObject, currObj, key) => {
  const currentPositions = currObj[POSITIONS_KEY] ?? [];

  const keyValue = queryObject[key]
    ? queryObject[key].split(",").map(Number)
    : [];

  return [...currentPositions, ...keyValue];
};

const handleOS = (queryObject, currObj, key) => {
  const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    [OS_LABEL]: { ...currentOS, [key]: Number(queryObject[key]) },
  });
};

const handleGraduationOS = (queryObject, currObj, key) => {
  // const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    // [OS_LABEL]: { ...currentOS,
    [key]: Number(queryObject[key]),
  });
};

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        const key = currKey === MAINLINE_POSITION_KEY ? POSITIONS_KEY : currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(currKey)) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFormattedGraduationQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        const key = currKey === MAINLINE_POSITION_KEY ? POSITIONS_KEY : currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(currKey)) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleGraduationOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // if (isDivision) {
      //   if (
      //     curr !== "divisionId" &&
      //     curr !== "memberId" &&
      //     curr !== "fullName"
      //   ) {
      //     return acc;
      //   }
      // }
      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
          : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool?.find(
          (p) =>
            (p.structureId ||
              p.divisionId ||
              p.cityId ||
              p.stateId ||
              p.specialGroupId) === Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value:
            selectedValue?.shortName ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            selectedValue?.name ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subdivisionId;
    delete updatedQueryWithOS.specialGroupId;
  }

  return updatedQueryWithOS;
};

export const columns = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "Member Name",
    key: "memberName",
  },
  {
    displayName: "Address",
    key: "address",
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Org Structure",
    key: "orgStructure",
  },
  {
    displayName: "Induction Date",
    key: "inductionDate",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

export const graduationColumns = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "Member Name",
    key: "memberName",
  },
  {
    displayName: "Address",
    key: "address",
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Org Structure",
    key: "orgStructure",
  },
  {
    displayName: "Graduation Date",
    key: "inductionDate",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

export const divisionColumns = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "Member Name",
    key: "memberName",
  },
  {
    displayName: "Address",
    key: "address",
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Org Structure",
    key: "orgStructure",
  },
  // {
  //   displayName: "Action",
  //   key: "action",
  // },
];

export const FDivisionColumns = [
  {
    displayName: Checkbox,
    key: "checkBox",
  },
  {
    displayName: "Member Name",
    key: "memberName",
  },
  {
    displayName: "Address",
    key: "address",
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Org Structure",
    key: "orgStructure",
  },
  {
    displayName: "Sub-Division",
    key: "subDivision",
  },
  {
    displayName: "University/ College",
    key: "university",
  },
  // {
  //   displayName: "Action",
  //   key: "action",
  // },
];
